import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/SearchRounded';
import Popover from '@mui/material/Popover';
import CircularProgress from '@mui/material/CircularProgress';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import endpoints, { apiRequest } from '../../../endpoints';
import axios from 'axios';

import SearchViewModal from '../modals/SearchViewModal'

let searchTimeout = null
let searchRequest = null;

const SearchBox = (props) => {
    const searchInputRef = useRef(null);
    const searchInputPopupRef = useRef(null);
    const searchBoxRef = useRef(null);
    const searchScrollRef = useRef(null);
    const [searchOpen, setSearchOpen] = useState(false)
    const [searchOpened, setSearchOpened] = useState(false)
    const [searchText, setSearchText] = useState('')
    const [list, setList] = useState([])
    const [page, setPage] = useState(0)
    const [listTotal, setListTotal] = useState(0)    
    const [loading, setLoading] = useState(false)
    const [loadNextPage, setLoadNextPage] = useState(false)
    
    const [searchView, setSearchView] = useState(false)
    
    const token = useSelector((state) => state.auth.token)
    
    useEffect(() => {
        if (searchOpen) {
            setTimeout(() => {
                searchInputPopupRef.current.value = searchInputRef.current.value
                searchInputPopupRef.current.focus()
                setPage(0)
                setSearchText(searchInputRef.current.value)
                setTimeout(() => {
                    setSearchOpened(true)
                }, 300)
            }, 0)
        } else {
            setSearchOpened(false)
        }
    }, [searchOpen])
    
    useEffect(() => {
        if (searchRequest) {
            searchRequest.cancel()
        }
        
        setLoading(true)
        clearTimeout(searchTimeout)
        
        if (searchText == '') {
            setListTotal(0)
            setList([])
            setLoading(false) 
            setLoadNextPage(false)
        } else {
            if (page == 0) {
                setListTotal(0)
                setList([])
            }
            searchTimeout = setTimeout(async () => {
                try {
                    searchRequest = axios.CancelToken.source()
                    const res = await apiRequest('get', endpoints.search, {
                        token: token,
                        filter: searchText,
                        page: page,
                        perpage: 10,
                        cancelToken: searchRequest.token
                    })
                    setListTotal(res.data.total)
                    if (page == 0) {
                        setList(res.data.items)
                    } else {
                        setList(list.concat(res.data.items))
                    }
                    setLoading(false)
                    setLoadNextPage(false)
                } catch (err) {
                    if (axios.isCancel(err)) {
                        //
                    } else if (err.name === 'CanceledError') {
                        //
                    } else {
                        if (page == 0) {
                            setListTotal(0)
                            setList([])
                        }
                        setLoading(false)
                        setLoadNextPage(false)
                    }
                }
            }, 500)
        }
    }, [searchText, page])
    
    useEffect(() => {
        if (loadNextPage && !loading && listTotal > list.length) {
            setPage(page + 1)
        }
    }, [loadNextPage])
    
    const scrollHandler = (e) => {
        if (!searchScrollRef.current) {
            return
        }
        
        const scroller = searchScrollRef.current;
        
        if (scroller.scrollTop + scroller.offsetHeight > scroller.scrollHeight - 60) {
            setLoadNextPage(true)
        }
    }
    
    useEffect(() => {
        setTimeout(() => {
            searchScrollRef.current?.removeEventListener('scroll', scrollHandler)
            searchScrollRef.current?.addEventListener('scroll', scrollHandler)
        }, 0)
    }, [searchOpen])
    
    useEffect(() => {        
        return () => {
            searchScrollRef.current?.removeEventListener('scroll', scrollHandler)
        }
    }, [])
       
    return (
        <>
            <Paper
                component="form"
                sx={{ p: '0px', display: 'flex', alignItems: 'center', width: props.width || 400, maxHeight: '60vh', opacity: searchOpened ? '0' : 1, }}
                ref={searchBoxRef}
            >
                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                </IconButton>
                <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search In All Feeds"
                    inputProps={{ 'aria-label': 'search in all feeds' }}
                    inputRef={searchInputRef}
                    onChange={(e) => {setSearchOpen(true)}}
                />
            </Paper>
            <Popover
                id={'searchBoxPopup'}
                open={searchOpen}
                anchorEl={searchBoxRef.current}
                onClose={() => {
                    searchInputRef.current.value = ''
                    searchInputPopupRef.current.value = ''
                    setSearchOpen(false)
                    setPage(0)
                    setSearchText('')
                    setList([])
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                sx={{ minWidth: props.width || 400, mt: '-8px' }}
            >
                <Stack
                    component="form"
                    direction="row"
                    sx={{ p: '0px', display: 'flex', alignItems: 'center', width: props.width || 400, borderBottom: '1px solid #cccccc',}}
                >
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search In All Feeds"
                        inputProps={{ 'aria-label': 'search in all feeds' }}
                        inputRef={searchInputPopupRef}
                        onChange={(e) => {
                            setPage(0) 
                            setSearchText(e.target.value)
                        }}
                    />
                </Stack>
                <Stack ref={searchScrollRef} sx={{height: '350px', maxWidth: props.width || 400, overflowY: 'auto'}}>                    
                    {list.length ?
                    <MenuList>
                        {list.map((row, key) => {
                            return (
                                <MenuItem sx={{whiteSpace: 'normal'}} key={row.id}>
                                    <ListItemText primary={row.title} secondary={row.feed.name} onClick={() => {setSearchView(row)}}/>
                                </MenuItem>
                            )
                        })}
                    </MenuList>        
                    : null }
                    {loading ? 
                    <Stack sx={{minHeight: '120px', height: '100%'}}>
                        <CircularProgress size={42} sx={{ margin: 'auto', color: 'primary.main' }} />
                    </Stack> 
                    : null }
                    {!loading && listTotal > 0 ? <Stack sx={{minHeight: '120px', height: '100%'}}/> : null }
                    {!loading && listTotal == 0 ? <p align="center">Nothing found for the search query.</p> : null }                                        
                </Stack>
            </Popover>
            <SearchViewModal 
                dialogData={searchView}
                onClose={() => {setSearchView(null)} }
            />
        </>
    )
}

export default SearchBox